export const Images = {
    up: 'images/up.svg',
    down: 'images/down.svg',
    hamburger: 'images/hamburger.svg',
    filter: 'images/filter.svg',
    download: 'images/download.svg',
    noRecord: 'images/no-record.svg',
};
